import instance from './Api';

const DICTIONARY_PATH = '/dictionary';

const getCountries = () => instance.get(`${DICTIONARY_PATH}/countries`);
const getVerificationMethods = () =>
  instance.get(`${DICTIONARY_PATH}/verification-methods`);

export default { getCountries, getVerificationMethods };
